import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    inventory_detail: {
        batch: [{
            product_id: "",
            available_units: "",
            units: "",
            total_units: "",
            expired_on: null,
            expire_alert: null,
            bogo_enabled: false,
            quantity: "",
        }
        ],
        place: "",
        supervisor_ids: [
            0
        ],
        admin_ids: [],
        customer_engagement_admin_ids: [],
        details_id: '',
        purchased_on: null,
        supplier: '',
        invoice: '',
        batch_no: '',

    },
    inventoryDetailsEdit: false,
    inventoryEdit: false,
    inventory: [],
    inventoryForm: {
        place: '',
        mobileno: '',
        supervisor_ids: [],
        admin_ids: [],
        customer_engagement_admin_ids: [],
        cashier_ids: [],
        franchise_id: '', // Added franchise_id field
        hub_setup: '', // Can be 'pincode' or 'radius'
        pincodes: [
            {
                pincode: '',
                latitude: '',
                longitude: '',
                hub_address: '',
                inner_radius: '',
                outter_radius: '',
                radius_increase_delivery_fee: '',
                north_latitude: '',
                north_longitude: '',
                south_latitude: '',
                south_longitude: '',
                east_latitude: '',
                east_longitude: '',
                west_latitude: '',
                west_longitude: ''
            }
        ],
        delivery_fee: '',
        self_pickup_waiver: false,
        self_pickup_waiver_percentage: '',
        delivery_status : '',
        delivery_mini_spent: '',
        shop_open_at: null,
        shop_close_at: null
    },
    modal: false,
    inventoryDetailsModal: false,
    allInventryDetails: [],
    supervisors: [],
    admins: [],
    customerEngagementAdmins: [],
    cashiers: [],
    hubsupervisors: [],
    inventoryLoading: false,
    inventoryDetailsLoading: false,
    selectedInventoryId: {},
    inventoryBatchModal: false,
    inventoryBatchForm: [{
        quantity: '',
        purchased_on: null,
        Expired: "",
        Set_expire_alert: ""
    }],
    inventoryBatchEdit: false,
    batchHistory: [],
    selectedBatchNo: "",
    batchHistoryLoading: false,
    searchBatchProduct: "",
    totalOrdered: 0,
    available: 0,
    inventoryProductSearch: "",
    
    // Franchise management state
    franchises: [],
    franchiseForm: {
        name: '',
        description: '',
        contact_person: '',
        contact_email: '',
        contact_phone: '',
        address: '',
        is_active: true
    },
    franchiseModal: false,
    franchiseEdit: false,
    franchiseLoading: false,
    selectedFranchiseId: null,

    // Stall management state
    stalls: [],
    stallForm: {
        hub: '',
        stall_name: '',
        pincode: '',
        latitude: '',
        longitude: '',
        stall_address: '',
        icon_url: '',
        is_active: true,
        isViewOnly: false
    },
    stallModal: false,
    stallEdit: false,
    stallLoading: false,
    selectedStallId: null,

};


const inventoryReducer = createSlice({
    name: "inventoryReducer",
    initialState: initialState,
    reducers: {
        updateInventoryDetail: (state, { type, payload }) => {
            state.inventory_detail = payload
        },
        updateInventory: (state, { type, payload }) => {
            console.log(payload)
            state.inventory = payload
        },
        updateInventoryModal: (state, { type, payload }) => {
            state.modal = payload
        },
        updateinventoryDetailsEdit: (state, { payload }) => {
            state.inventoryDetailsEdit = payload
        },
        updateallInventryDetails: (state, { payload }) => {
            state.allInventryDetails = payload
        },
        updateInventrySupervisors: (state, { payload }) => {
            state.supervisors = payload
        },
        updateInventryAdmins: (state, { payload }) => {
            state.admins = payload
        },
        updateInventryCustomerEngagementAdmins: (state, { payload }) => {
            state.customerEngagementAdmins = payload
        },
        updateInventryCashiers: (state, { payload }) => {
            state.cashiers = payload
        },
        updateInventryHubsupervisors: (state, { payload }) => {
            state.hubsupervisors = payload
        },
        updateInventoryDetailsModal: (state, { type, payload }) => {
            state.inventoryDetailsModal = payload
        },
        updateInventoryform: (state, { type, payload }) => {
            state.inventoryForm = payload
        },
        updateinventoryEdit: (state, { payload }) => {
            state.inventoryEdit = payload
        },
        updateInventoryLoading: (state, { payload }) => {
            state.inventoryLoading = payload
        },
        updateInventorySearchProduct: (state, { payload }) => {
            state.inventoryProductSearch = payload
        },
        updateInventoryDetailsLoading: (state, { payload }) => {
            state.inventoryDetailsLoading = payload
        },
        updateInventorySearchProduct: (state, { payload }) => {
            state.inventoryProductSearch = payload
        },
        updateSelectedInventoryId: (state, { payload }) => {
            state.selectedInventoryId = payload
            localStorage.setItem("selectedProduct", JSON.stringify(payload))
        },

        updateInventoryBatchModal: (state, { payload }) => {
            state.inventoryBatchModal = payload
        },
        updateInventoryBatchForm: (state, { payload }) => {
            state.inventoryBatchForm = payload
        },
        updateInventoryBatchEdit: (state, { payload }) => {
            state.inventoryBatchEdit = payload
        },
        updateBatchHistory: (state, { payload }) => {
            state.batchHistory = payload
        },
        updateSelectedBatchNo: (state, { payload }) => {
            state.selectedBatchNo = payload
        },
        updateBatchHistoryLoading: (state, { payload }) => {
            state.batchHistoryLoading = payload
        },
        updatesearchBatchProduct: (state, { payload }) => {
            state.searchBatchProduct = payload
        },
        updateTotalOrdered: (state, { payload }) => {
            state.totalOrdered = payload
        },
        updateAvailable: (state, { payload }) => {
            state.available = payload
        },
        updateInventoryProductSearch: (state, { payload }) => {
            state.inventoryProductSearch = payload
        },
        
        // Franchise management reducers
        updateFranchises: (state, { payload }) => {
            state.franchises = payload
        },
        updateFranchiseForm: (state, { payload }) => {
            state.franchiseForm = payload
        },
        updateFranchiseModal: (state, { payload }) => {
            state.franchiseModal = payload
        },
        updateFranchiseEdit: (state, { payload }) => {
            state.franchiseEdit = payload
        },
        updateFranchiseLoading: (state, { payload }) => {
            state.franchiseLoading = payload
        },
        updateSelectedFranchiseId: (state, { payload }) => {
            state.selectedFranchiseId = payload
        },
        resetFranchiseForm: (state) => {
            state.franchiseForm = {
                name: '',
                description: '',
                contact_person: '',
                contact_email: '',
                contact_phone: '',
                address: '',
                is_active: true,
                logo_url: '',
                background_color: '',
                content_color: '',
                border_color: ''
            }
        },
        
        // Stall management reducers
        updateStalls: (state, { payload }) => {
            state.stalls = payload
        },
        updateStallForm: (state, { payload }) => {
            state.stallForm = payload
        },
        updateStallModal: (state, { payload }) => {
            state.stallModal = payload
        },
        updateStallEdit: (state, { payload }) => {
            state.stallEdit = payload
        },
        updateStallLoading: (state, { payload }) => {
            state.stallLoading = payload
        },
        updateSelectedStallId: (state, { payload }) => {
            state.selectedStallId = payload
        },
        resetStallForm: (state) => {
            state.stallForm = {
                hub: '',
                stall_name: '',
                pincode: '',
                latitude: '',
                longitude: '',
                stall_address: '',
                icon_url: '',
                is_active: true,
                isViewOnly: false
            }
        }
    }
})

export const { updateInventory, updateInventoryModal, updateInventoryDetail, updateEdit, updateallInventryDetails, updateinventoryDetailsEdit, updateInventryHubsupervisors, updateInventrySupervisors, updateInventryAdmins, updateInventryCustomerEngagementAdmins, updateInventryCashiers, updateInventoryDetailsModal, updateInventorySearchProduct, updateInventoryform, updateinventoryEdit, updateInventoryLoading, updateInventoryDetailsLoading,
    updateSelectedInventoryId, updateInventoryBatchModal, updateInventoryBatchForm, updateBatchHistory, updateSelectedBatchNo, updateBatchHistoryLoading, updatesearchBatchProduct, updateTotalOrdered, updateAvailable, updateInventoryProductSearch,
    updateFranchises, updateFranchiseForm, updateFranchiseModal, updateFranchiseEdit, updateFranchiseLoading, updateSelectedFranchiseId, resetFranchiseForm,
    updateStalls, updateStallForm, updateStallModal, updateStallEdit, updateStallLoading, updateSelectedStallId, resetStallForm
} = inventoryReducer.actions



export default inventoryReducer.reducer;